import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {getWrappedElement as $b02497e8694279b1$export$a5f5a6912b18861c} from "../utils/getWrappedElement.mjs";
import "../link_vars.css";
import $054Ox$link_vars_cssmjs from "../link_vars_css.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useSlotProps as $62024859ff9f1f8a$export$1e5c9e6e4e15efe3} from "../utils/Slots.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useLink as $054Ox$useLink} from "react-aria/useLink";
import {FocusRing as $054Ox$FocusRing} from "react-aria/FocusRing";
import {mergeProps as $054Ox$mergeProps} from "react-aria/mergeProps";
import {mergeRefs as $054Ox$mergeRefs} from "react-aria/mergeRefs";
import $054Ox$react, {useRef as $054Ox$useRef} from "react";
import {useHover as $054Ox$useHover} from "react-aria/useHover";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 











let $ce09639bc16e0ff3$var$isOldReact = parseInt((0, $054Ox$react).version, 10) <= 18;
function $ce09639bc16e0ff3$export$a6c7ac8248d6e38a(props) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $62024859ff9f1f8a$export$1e5c9e6e4e15efe3)(props, 'link');
    let { variant: variant = 'primary', isQuiet: isQuiet, children: children, href: // @ts-ignore
    href } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $054Ox$useHover)({});
    let ref = (0, $054Ox$useRef)(null);
    let { linkProps: linkProps } = (0, $054Ox$useLink)({
        ...props,
        elementType: !href && typeof children === 'string' ? 'span' : 'a'
    }, ref);
    let domProps = {
        ...styleProps,
        ...(0, $054Ox$mergeProps)(linkProps, hoverProps),
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($054Ox$link_vars_cssmjs))), 'spectrum-Link', {
            'spectrum-Link--quiet': isQuiet,
            [`spectrum-Link--${variant}`]: variant,
            'is-hovered': isHovered
        }, styleProps.className)
    };
    let link;
    if (href) link = /*#__PURE__*/ (0, $054Ox$react).createElement("a", domProps, children);
    else {
        // Backward compatibility.
        let wrappedChild = (0, $b02497e8694279b1$export$a5f5a6912b18861c)(children);
        let mergedRef = ref;
        if ($ce09639bc16e0ff3$var$isOldReact) // @ts-ignore
        mergedRef = (0, $054Ox$mergeRefs)(ref, wrappedChild.ref);
        else // @ts-ignore
        mergedRef = (0, $054Ox$mergeRefs)(ref, wrappedChild.props.ref);
        link = /*#__PURE__*/ (0, $054Ox$react).cloneElement(wrappedChild, {
            ...(0, $054Ox$mergeProps)(wrappedChild.props, domProps),
            // @ts-ignore https://github.com/facebook/react/issues/8873
            ref: mergedRef
        });
    }
    return /*#__PURE__*/ (0, $054Ox$react).createElement((0, $054Ox$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($054Ox$link_vars_cssmjs))), 'focus-ring')
    }, link);
}


export {$ce09639bc16e0ff3$export$a6c7ac8248d6e38a as Link};
//# sourceMappingURL=Link.mjs.map
